import { ShopIdContext } from "context/orderFormContexts/ShopIdContext"
import { useContext } from "react"

export function useShopId() {
  const shopIdContext = useContext(ShopIdContext)
  return shopIdContext.shopId as string | undefined
}
